var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VanBtn',{staticClass:"plain-btn",class:{ border: _vm.border },attrs:{"size":"large"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }